export default function isMaterialWarehouse() {
  // 项目运行时需要通过 process.env 获取配置时，需要通过 webpack.DefinePlugin 把对应的值种进去
  return process.env.PROJECT_TYPE === 'warehouse'
}

export function isAssetsFactory() {
  return process.env.PROJECT_TYPE === 'assets-factory'
}

export function isCloudClip() {
  return process.env.PROJECT_TYPE === 'cloud-clip'
}
